import { ReducerAction } from 'store/modules/types';

import { Types, IRequestGerarRenach } from './types';

export function gerarRenachTransferenciaMunicipalRequest(
	data: IRequestGerarRenach,
): ReducerAction {
	return {
		type: Types.GERAR_RENACH_TRANSFERENCIA_MUNICIPAL,
		payload: data,
	};
}
export function gerarRenachTransferenciaMunicipalSuccess(
	payload: object,
): ReducerAction {
	return {
		type: Types.GERAR_RENACH_TRANSFERENCIA_MUNICIPAL_SUCCESS,
		payload,
	};
}
export function gerarRenachTransferenciaMunicipalFailure(
	payload: boolean,
): ReducerAction {
	return {
		type: Types.GERAR_RENACH_TRANSFERENCIA_MUNICIPAL_FAILURE,
		payload,
	};
}
